import React, { useState } from "react";
import {
  Block,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
  Button,
  Icon,
  PreviewCard,
} from "../../components/Component";
import Logo from "../../images/logo.png";
import LogoDark from "../../images/logo-dark.png";
import { Form, Spinner, Alert } from "reactstrap";
import PageContainer from "../../layout/page-container/PageContainer";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Api from "../../Api";
//import Api from "../../Api";
import SimpleCrypto from "simple-crypto-js";
const _secretKey = "fte-srt-ky-1";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [passState, setPassState] = useState(false);
  const [errorVal, setError] = useState("");


  const doLogin = async (formData) => {
    setLoading(true);
    const token = await Api.AuthToken(formData);
    if (token.message === "token generate.") {
      localStorage.setItem("tokenAdmin", JSON?.stringify(token));
      localStorage.setItem("formCd", JSON?.stringify(formData));
      localStorage.setItem("countsAdmin", Date.now());
      const login = await Api.ClientLogin(formData, token.data.access_token);
      localStorage?.setItem("userTypeId", login?.data?.userTypeId);
      localStorage?.setItem("formDataUsername", login?.data?.userName);
      localStorage.setItem("accessToken", "token");
      localStorage?.setItem("gettenantId", login?.data?.tenantId);
      setTimeout(() => {
        window.history.pushState(
          `${process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/Tenant/Accounts/manage-tenant` : `${process.env.PUBLIC_URL}/Tenant/Accounts/manage-tenant`}`,
          "auth-login",
          `${process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/Tenant/Accounts/manage-tenant` : `${process.env.PUBLIC_URL}/Tenant/Accounts/manage-tenant`}`
        );
        window.location.reload();
      }, 2000);
    } else {
      setTimeout(() => {
        setError(token.message);
        setLoading(false);
      }, 2000);
    }

  };

  const onFormSubmit = (formData) => {
    setLoading(true);
    const loginName = "info@softnio.com";
    const pass = "123456";
    if (formData.name === loginName && formData.passcode === pass) {
      localStorage.setItem("accessToken", "token");
      setTimeout(() => {
        window.history.pushState(
          `${process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/` : `${process.env.PUBLIC_URL}/manage-users`}`,
          "auth-login",
          `${process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/manage-users` : `${process.env.PUBLIC_URL}/manage-users`}`
        );
        window.location.reload();
      }, 2000);
    } else {
      setTimeout(() => {
        setError("Cannot login with credentials");
        setLoading(false);
      }, 2000);
    }
  };

  const { errors, register, handleSubmit } = useForm();

  return (
    <React.Fragment>
      <Head title="Login" />
      <PageContainer>
        <Block className="nk-block-middle nk-auth-body  wide-xs">
          <div className="brand-logo pb-4 text-center">
            <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
              <img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
              <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" />
            </Link>
          </div>

          <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
            <BlockHead>
              <BlockContent>
                <BlockTitle tag="h4" className="justify-center mb-2">Administrative login</BlockTitle>
              </BlockContent>
            </BlockHead>
            {errorVal && (
              <div className="mb-3">
                <Alert color="danger" className="alert-icon">
                  {" "}
                  <Icon name="alert-circle" /> Unable to login with credentials{" "}
                </Alert>
              </div>
            )}
            <Form className="is-alter" onSubmit={handleSubmit(doLogin)}>
              <div className="form-group">
                <div className="form-label-group">
                  <label className="form-label" htmlFor="default-01">
                    User Name
                  </label>
                </div>
                <div className="form-control-wrap">
                  <input
                    type="text"
                    id="default-01"
                    name="name"
                    ref={register({ required: "This field is required" })}
                    placeholder="Enter your email address or username"
                    className="form-control-lg form-control bg-azure-dim"
                    tabIndex={1}
                  />
                  {errors.name && <span className="invalid">{errors.name.message}</span>}
                </div>
              </div>
              <div className="form-group">
                <div className="form-label-group">
                  <label className="form-label" htmlFor="password">
                    Password
                  </label>
                </div>
                <div className="form-control-wrap">
                  <a
                    href="#password"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setPassState(!passState);
                    }}
                    className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                  >
                    <Icon name="eye" className="passcode-icon icon-show"></Icon>

                    <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                  </a>
                  <input
                    type={passState ? "text" : "password"}
                    id="password"
                    name="passcode"
                    ref={register({ required: "This field is required" })}
                    placeholder="Enter your passcode"
                    className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"} bg-azure-dim`}
                    tabIndex={2}
                  />

                  <Link className="link link-primary link-sm justify-end mt-2" to={`${process.env.PUBLIC_URL}/auth-reset`}>
                    Forgot Password?
                  </Link>
                  {errors.passcode && <span className="invalid">{errors.passcode.message}</span>}
                </div>
              </div>
              <div className="form-group">
                <Button size="lg" className="btn-block" type="submit" color="primary"tabIndex={3}>
                  {loading ? <Spinner size="sm" color="light" /> : "Sign in"}
                </Button>
              </div>
            </Form>
          </PreviewCard>
        </Block>
        <AuthFooter />
      </PageContainer>
    </React.Fragment>
  );
};
export default Login;
